<template>
  <div>
    <div class="w-100 d-inline-block py-5 border-bottom" style="background-color: #f6f6f6;">
      <div class="container autoContent">
        <div class="row align-items-center">
          <div class="col-xl-7 col-lg-7 col-md-12 mb-4 mb-lg-0">
            <div class="w-100 d-inline-block">
              <h1 class="text-black fw-bold filson-black-family margin-bottom-4 text-xs-size-24" style="font-size: 38px;">
               {{ heroTitle }}
              </h1>
              <p class="mb-4 text-size-15 text-muted family-inter-light text-lh-large text-full-14">
                {{ heroParagraphs[0] }}
              </p>
              <p class="mb-0 text-size-15 text-muted family-inter-light text-lh-large text-full-14">
                {{ heroParagraphs[1] }}
              </p>
            </div>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-12 text-center text-lg-end">
            <img class="img-fluid" :key="`${activeWebsiteName}-hero-${heroImageSrc}`" v-lazy="heroImageSrc" :alt="heroTitle">
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-plans py-3">
      <div class="container autoContent">
        <div class="row mb-5">
          <div class="col-12 text-center">
            <p class="mb-2 text-uppercase nav-color fw-bold filson-black-family" style="letter-spacing: 1px; color:#F8721F;">
              OUR PLANS
            </p>
            <h2 class="text-black fw-bold filson-black-family text-uppercase margin-bottom-3" style="font-size: 32px;">
              {{ planSectionHeading }}
            </h2>
            <p class="text-size-15 text-muted family-inter-light text-lh-large mx-auto" style="max-width: 800px;">
              {{ planSectionIntro }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="w-100 d-inline-block gallery-slider about-slider position-relative">
              <div class="carousel-container">
                <transition-group class="carousel d-flex" style="gap: 20px;" tag="div">
                  <div v-for="(plan) in planDetailPrices" :key="`${activeWebsiteName}-${plan.id}`" class="slide" style="flex: 0 0 calc(25% - 15px);">
                    <div class="card w-100 h-100 d-flex flex-column border-0 rounded-4 plan-card shadow-sm" style="overflow: hidden; background-color: #FFF;">
                      <img class="slide-image w-100" v-lazy="$getImageUrl(plan.image)" :alt="plan.name" style="height: 200px; object-fit: cover;">
                      <div class="card-body p-4 d-flex flex-column flex-grow-1">
                        <h3 class="card-title text-size-16 filson-black-family fw-bold margin-bottom-2 text-black">
                          {{ plan.name }}
                        </h3>
                        <p class="card-text text-muted text-size-14 family-inter-light mb-4 text-lh-large flex-grow-1">
                          {{ plan.description }}
                        </p>
                        <div class="mt-auto d-flex justify-content-between align-items-center plan-card-cta">
                          <a href="javascript:void(0)" class="btn btn-outline-secondary text-uppercase text-size-12 fw-bold px-3 py-2 btn-book-service"
                            @click="addToCart(plan)">
                            BOOK SERVICE
                          </a>
                          <span class="text-size-18 fw-bold filson-black-family price-text">
                            {{ plan.unit }}{{ plan.price }} 
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
                <div class="carousel-dots w-100 d-flex justify-content-center mt-5">
                  <span class="dot mx-1" @click="previous()"></span>
                  <span class="dot mx-1 active"></span>
                  <span class="dot mx-1" @click="next()"></span>
                  <span class="dot mx-1" @click="next()"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- New Images Grid Section -->
    <div class="w-100 d-inline-block bg-white py-3">
      <div class="container autoContent mb-xl-4 mb-2">
        <div class="row g-3">
          <div class="col-md-6 col-12" v-for="(gSrc, gIdx) in galleryImages" :key="`${activeWebsiteName}-g-${gIdx}-${gSrc}`">
            <img class="img-fluid rounded-4 w-100 service-gallery-image" v-lazy="gSrc" alt="Service gallery">
          </div>
        </div>
      </div>
    </div>
    
    <!-- Why You Should Choose Us (full-width) -->
    <div class="w-100 d-inline-block bg-white py-5">
      <div class="container-fluid px-3 px-md-4 px-xl-5">
        <div class="row">
          <div class="col-12 text-center">
            <div class="w-100 d-inline-block mx-auto choose-us-heading-wrap">
              <p class="mb-2 text-uppercase nav-color fw-bold filson-black-family" style="letter-spacing: 1px; color:#F8721F;">
                WHY YOU SHOULD CHOOSE US
              </p>
              <h2 class="text-black fw-bold filson-black-family margin-bottom-3 text-uppercase" style="font-size: 32px;">
                {{ chooseUsHeading }}
              </h2>
              <p class="mb-0 text-size-14 text-muted family-inter-light text-lh-large text-full-13 mx-auto choose-us-lead">
                {{ chooseUsBody }}
              </p>
            </div>
          </div>
        </div>
        <div class="container autoContent">
        <div class="row align-items-center g-4 mt-4">
          <!-- Column 1 (2 rows) -->
          <div class="col-lg-4 col-md-6">
            <div class="choose-us-stack">
              <div class="choose-us-item" v-for="(benefit, bIdx) in chooseUsBenefitColumns[0]" :key="`benefit-left-${bIdx}`">
                <div class="d-flex gap-3 align-items-start">
                  <div class="choose-us-icon flex-shrink-0 d-flex align-items-center justify-content-center">
                    <img v-if="benefit.image" class="choose-us-icon-img" :src="benefit.image" :alt="benefit.title">
                    <i v-else :class="benefit.icon" aria-hidden="true"></i>
                  </div>
                  <div>
                    <h3 class="mb-1 text-black fw-bold filson-black-family text-size-14">
                      {{ benefit.title }}
                    </h3>
                    <p class="mb-0 text-muted family-inter-light text-size-13 text-lh-large">
                      {{ benefit.body }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Column 2 (2 rows) -->
          <div class="col-lg-4 col-md-6">
            <div class="choose-us-stack">
              <div class="choose-us-item" v-for="(benefit, bIdx) in chooseUsBenefitColumns[1]" :key="`benefit-right-${bIdx}`">
                <div class="d-flex gap-3 align-items-start">
                  <div class="choose-us-icon flex-shrink-0 d-flex align-items-center justify-content-center">
                    <img v-if="benefit.image" class="choose-us-icon-img" :src="benefit.image" :alt="benefit.title">
                    <i v-else :class="benefit.icon" aria-hidden="true"></i>
                  </div>
                  <div>
                    <h3 class="mb-1 text-black fw-bold filson-black-family text-size-14">
                      {{ benefit.title }}
                    </h3>
                    <p class="mb-0 text-muted family-inter-light text-size-13 text-lh-large">
                      {{ benefit.body }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Column 3 (image) -->
          <div class="col-lg-4 col-12">
            <div class="choose-us-image-wrap mx-auto">
              <img
                class="img-fluid choose-us-image"
                :key="`${activeWebsiteName}-choose-${chooseUsImageSrc}`"
                v-lazy="chooseUsImageSrc"
                :alt="heroTitle"
              >
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <!-- FAQ (next section, two columns) -->
    <div class="w-100 d-inline-block py-5" style="background-color: #F8F9FA;">
      <div class="container autoContent">
        <div class="row mb-4">
          <div class="col-12 text-center">
            <p class="mb-2 text-uppercase nav-color fw-bold filson-black-family" style="letter-spacing: 1px; color:#F8721F;">
              FAQ
            </p>
            <h2 class="text-black fw-bold filson-black-family text-uppercase margin-bottom-2" style="font-size: 32px;">
              Frequently Asked Questions
            </h2>
          </div>
        </div>

        <div class="row g-3" id="serviceFaqAccordion">
          <div class="col-lg-6 col-12" v-for="(faqCol, colIdx) in faqColumns" :key="`faq-col-${colIdx}`">
            <div
              class="w-100 d-inline-block pets-collapse bg-white rounded-3 shadow-sm px-4 py-3 border-0"
              v-for="(faqItem, faqIdx) in faqCol"
              :key="`faq-${colIdx}-${faqIdx}`"
              style="margin-bottom: 16px;"
            >
              <a
                class="family-filson-bold text-black text-size-14 fw-bold w-100 d-flex align-items-center text-decoration-none"
                href="javascript:void(0)"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapseFaq' + faqItem._idx"
                :aria-expanded="faqItem._idx === 0"
                :aria-controls="'collapseFaq' + faqItem._idx"
              >
                <i class="fa fa-check-circle-o nav-color me-3" style="font-size: 20px;" aria-hidden="true"></i>
                <span class="text-full-14 text-size-14">{{ faqItem.question }}</span>
              </a>
              <div
                :id="'collapseFaq' + faqItem._idx"
                class="collapse mt-3 ms-4 ps-2"
                :class="{ show: faqItem._idx === 0 }"
                data-bs-parent="#serviceFaqAccordion"
              >
                <p class="mb-0 text-size-14 text-muted family-inter-light text-lh-large text-full-13">
                  {{ faqItem.answer }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-orange">
      <div class="container autoContent">
        <div class="row margin-top-1 margin-bottom-0">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                <i class="fa fa-home text-black" aria-hidden="true"></i>
                Home /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
                Services
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { pathWithoutCountryForServicesApi, withCountryPath } from '@/utils/countryPath';

export default {
    name: 'serviceCategoryBannerComponent',
    data() {
    return {
      planDetailPrices: [],
      categoryNameForPlans: 'Services',
      apiCategoryDescription: '',
      apiCategoryImage: '',
      apiLongDescription: '',
      apiServiceHeading: '',
      apiPlanHeading: '',
      apiPlanContent: '',
      apiChooseUs: '',
      apiChooseUsHeading: '',
      apiChooseUsImage: '',
      apiChooseUsUses: null,
      apiGalleryImages: [],
      apiFaq: [],
      pageLoadSeq: 0,
      defaultHeroP1:
        'Welcome to our mobile pet grooming service. We offer professional, caring grooming tailored to your pet, with flexible booking and experienced groomers dedicated to your companion\'s comfort and wellbeing.',
      defaultHeroP2:
        'From routine care to full spa packages, we focus on quality, hygiene, and a stress-free experience—at your home or our spa, depending on what suits you best.',
      defaultPlanHeading: 'SERVICES WE OFFER',
      defaultPlanIntro:
        'Explore our plans and packages designed for your pet. Choose the level of care that fits your needs and budget.',
      defaultChooseUs:
        'Choosing us means personalized attention, qualified groomers, and a commitment to making every visit safe and pleasant for your pet.',
      defaultChooseUsHeading: 'Best Services For Your Pets',
      defaultFaq: [
        {
          question: 'How do I book a grooming session?',
          answer:
            'Use our online booking flow or contact us by phone. Pick a date and the services you need—we will confirm your appointment.',
        },
        {
          question: 'What is included in a grooming package?',
          answer:
            'Packages vary by plan. Each option lists what is included, from basic baths to full grooming with nail care and styling.',
        },
        {
          question: 'Are your products safe for sensitive pets?',
          answer:
            'We use gentle, pet-appropriate products. Tell us about any allergies or sensitivities when you book so we can adapt.',
        },
      ],
      chooseUsBenefits: [
        {
          title: 'Experienced Groomers',
          body: 'Skilled, gentle handling for all breeds and temperaments.',
          image: require('@/assets/images/vip-service-icon.svg'),
        },
        {
          title: 'Pet-First Care',
          body: 'Comfort, safety, and hygiene are built into every visit.',
          image: require('@/assets/images/every-pet-icon.svg'),
        },
        {
          title: 'On-Time Appointments',
          body: 'Convenient scheduling that respects your day and your pet.',
          image: require('@/assets/images/clock-icon.svg'),
        },
        {
          title: 'Safe Products',
          body: 'Pet-friendly products tailored to sensitive skin when needed.',
          image: require('@/assets/images/basic-grooming-icon.svg'),
        },
        {
          title: 'Doorstep Convenience',
          body: 'Mobile grooming at your location for a stress-free experience.',
          image: require('@/assets/images/location-service-icon.svg'),
        },
        {
          title: 'Premium Results',
          body: 'A clean, neat finish that keeps your pet looking and feeling great.',
          image: require('@/assets/images/full-grooming-icon.svg'),
        },
      ],
    };
  },
      mounted() {
        this.loadServicePageData();
        this.unwatchWebsite = this.$watch(
          () => this.activeWebsiteName,
          () => {
            this.loadServicePageData();
          }
        );
        this.unwatchRoute = this.$watch(
          () => this.$route.fullPath,
          () => {
            this.loadServicePageData();
          }
        );
      },
      beforeUnmount() {
        this.unwatchWebsite?.();
        this.unwatchRoute?.();
      },
      computed: {
        categorySlug() {
          const s = this.$route.params.slug;
          return s != null ? String(s).replace(/\/+$/, '') : '';
        },
        heroTitle() {
          return this.apiServiceHeading || this.categoryNameForPlans || 'Our services';
        },
        heroParagraphs() {
          const long = this.apiLongDescription || '';
          if (long && /\n\n/.test(long)) {
            const parts = long
              .split(/\n\n+/)
              .map((p) => p.trim())
              .filter(Boolean);
            return [parts[0] || this.defaultHeroP1, parts[1] || ''];
          }
          return [long || this.defaultHeroP1, ''];
        },
        heroImageSrc() {
          return this.apiCategoryImage
            ? this.$getImageUrl(this.apiCategoryImage)
            : require('@/assets/images/dog-grooming-service.png');
        },
        planSectionHeading() {
          return this.apiPlanHeading || this.defaultPlanHeading;
        },
        planSectionIntro() {
          return this.apiPlanContent || this.defaultPlanIntro;
        },
        galleryImages() {
          const defaults = [
            require('@/assets/images/dog-grooming-1.png'),
            require('@/assets/images/dog-grooming-2.png'),
            require('@/assets/images/dog-grooming-3.png'),
            require('@/assets/images/dog-grooming-4.png'),
          ];
          const fromApi = (this.apiGalleryImages || []).map((path) => this.$getImageUrl(path));
          const out = [...fromApi];
          let d = 0;
          while (out.length < 4 && d < defaults.length) {
            out.push(defaults[d]);
            d += 1;
          }
          return out.slice(0, 4);
        },
        faqItems() {
          if (this.apiFaq && this.apiFaq.length) return this.apiFaq;
          return this.defaultFaq;
        },
        chooseUsHeading() {
          return this.apiChooseUsHeading || this.defaultChooseUsHeading;
        },
        chooseUsBenefitsResolved() {
          const apiItems = Array.isArray(this.apiChooseUsUses) ? this.apiChooseUsUses : [];
          if (apiItems.length) return apiItems;
          return Array.isArray(this.chooseUsBenefits) ? this.chooseUsBenefits : [];
        },
        chooseUsBenefitColumns() {
          const items = Array.isArray(this.chooseUsBenefitsResolved) ? this.chooseUsBenefitsResolved : [];
          // Layout requirement: 3 columns total; first two columns are stacked lists; last column is the image.
          // Split benefits into two columns as evenly as possible.
          const leftCount = Math.ceil(items.length / 2);
          return [items.slice(0, leftCount), items.slice(leftCount)];
        },
        faqColumns() {
          const items = (this.faqItems || []).map((f, idx) => ({ ...f, _idx: idx }));
          const left = [];
          const right = [];
          items.forEach((it, idx) => {
            (idx % 2 === 0 ? left : right).push(it);
          });
          return [left, right];
        },
        chooseUsBody() {
          return this.apiChooseUs || this.defaultChooseUs;
        },
        chooseUsImageSrc() {
          return this.apiChooseUsImage
            ? this.$getImageUrl(this.apiChooseUsImage)
            : require('@/assets/images/dog-service-video.png');
        },
      },
      methods: {
      extractChooseUsUsesFromApi(content) {
        if (!content) return [];
        const pairs = [
          { icon: 'first_use_icon', heading: 'first_use_heading', text: 'first_use_text' },
          { icon: 'second_use_icon', heading: 'second_use_heading', text: 'second_use_text' },
          { icon: 'third_use_icon', heading: 'third_use_heading', text: 'third_use_text' },
          { icon: 'fourth_use_icon', heading: 'fourth_use_heading', text: 'fourth_use_text' },
          { icon: 'fifth_use_icon', heading: 'fifth_use_heading', text: 'fifth_use_text' },
          { icon: 'six_use_icon', heading: 'six_use_heading', text: 'six_use_text' },
        ];

        return pairs
          .map((p) => {
            const iconPath = content[p.icon] || '';
            const heading = content[p.heading] || '';
            const text = content[p.text] || '';
            const hasAny = Boolean(iconPath || heading || text);
            if (!hasAny) return null;
            return {
              title: heading || '',
              body: text || '',
              image: iconPath ? this.$getImageUrl(iconPath) : null,
            };
          })
          .filter(Boolean);
      },
      clearCategoryContentFields() {
        this.apiServiceHeading = '';
        this.apiPlanHeading = '';
        this.apiPlanContent = '';
        this.apiLongDescription = '';
        this.apiChooseUs = '';
        this.apiChooseUsHeading = '';
        this.apiChooseUsImage = '';
        this.apiChooseUsUses = null;
        this.apiGalleryImages = [];
        this.apiFaq = [];
      },
      async loadServicePageData() {
        const seq = ++this.pageLoadSeq;
        await this.fetchCategoryPage(seq);
        if (seq !== this.pageLoadSeq) return;
        await this.fetchServiceCategories(seq);
      },
      async fetchCategoryPage(seq) {
        try {
          const form = new URLSearchParams();
          form.append('website_name', this.activeWebsiteName || '');
          form.append('slug', this.categorySlug || '');
          const pathForApi =
            this.categorySlug ? `/services/${this.categorySlug}/` : pathWithoutCountryForServicesApi(this.$route.path || '');
          form.append('path', pathForApi);
          const res = await this.$axios.post('/get-category-page', form);
          if (seq !== this.pageLoadSeq) return;
          if (res.data.status !== 'success') {
            this.clearCategoryContentFields();
            this.apiCategoryDescription = '';
            this.apiCategoryImage = '';
            this.categoryNameForPlans = this.categorySlug
              ? this.categorySlug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
              : 'Services';
            return;
          }
          const cat = res.data.category;
          const content = res.data.category_content;
          if (cat?.name) this.categoryNameForPlans = cat.name;
          this.apiCategoryDescription = cat?.description || '';
          this.apiCategoryImage = cat?.image || '';
          this.clearCategoryContentFields();
          if (content) {
            this.apiServiceHeading = content.service_heading || '';
            this.apiPlanHeading = content.plan_heading || '';
            this.apiPlanContent = content.plan_content || '';
            this.apiLongDescription = content.long_description || '';
            this.apiChooseUs = content.choose_us || '';
            this.apiChooseUsHeading = content.choose_us_heading || '';
            this.apiChooseUsImage = content.choose_us_image || '';
            this.apiChooseUsUses = this.extractChooseUsUsesFromApi(content);
            let imgs = content.images;
            if (typeof imgs === 'string' && imgs.trim()) {
              try {
                imgs = JSON.parse(imgs);
              } catch {
                imgs = [];
              }
            }
            this.apiGalleryImages = Array.isArray(imgs) ? imgs : [];
            let rawFaq = content.faq;
            if (typeof rawFaq === 'string' && rawFaq.trim()) {
              try {
                rawFaq = JSON.parse(rawFaq);
              } catch {
                rawFaq = [];
              }
            }
            this.apiFaq = Array.isArray(rawFaq)
              ? rawFaq
                  .map((f) => ({
                    question: f.question || '',
                    answer: f.answer || '',
                  }))
                  .filter((f) => f.question || f.answer)
              : [];
          }
        } catch (e) {
          console.error('get-category-page', e);
          if (seq === this.pageLoadSeq) {
            this.clearCategoryContentFields();
            this.apiCategoryDescription = '';
            this.apiCategoryImage = '';
          }
        }
      },
      addToCart(service) {
        const cartData = localStorage.getItem('cart');
        let cart = cartData ? JSON.parse(cartData) : []; // Parse the cart or initialize as an empty array

        const serviceExists = cart.find((item) => item.id === service.id);

        if (serviceExists) {
          serviceExists.count++;
        } else {
          cart.push({ ...service, count: 1 });
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        this.$router.push(withCountryPath('/booking/'));
      },
    async fetchServiceCategories(seq) {
      try {
        const form = new URLSearchParams();
        form.append('website_name', this.activeWebsiteName || '');
        form.append('category_name', this.categoryNameForPlans || '');
        const response = await this.$axios.post('/get-service-categories', form);
        if (seq !== this.pageLoadSeq) return;
        if (response.data.status === "success") {
          this.planDetailPrices = response.data.planDetailPrices || [];
        } else {
          console.error("Failed to fetch categories:", response.data);
          this.planDetailPrices = [];
        }
      } catch (error) {
        if (seq === this.pageLoadSeq) {
          console.error('Error fetching categories:', error.response || error.message);
          this.planDetailPrices = [];
        }
      }
    },
    previous() {
      const last = this.planDetailPrices.pop();
      this.planDetailPrices = [last].concat(this.planDetailPrices);
    },
    next() {
      const first = this.planDetailPrices.shift();
      this.planDetailPrices = this.planDetailPrices.concat(first);
    },
  },
  };
</script>
<style scoped>
.text-lh-large {
  line-height: 1.8;
}

.choose-us-heading-wrap {
  max-width: 980px;
}

.choose-us-lead {
  max-width: 880px;
}

.choose-us-stack {
  display: grid;
  gap: 22px;
}

.choose-us-item {
  padding: 0;
}

.choose-us-icon {
  width: 44px;
  height: 44px;
  /* border: 1.5px solid rgba(248, 114, 31, 0.35); */
  /* border-radius: 14px; */
  /* color: #F8721F; */
  /* background: rgba(248, 114, 31, 0.06); */
  font-size: 18px;
}

.choose-us-icon-img {
  width: 44px;
  height: 44px;
  object-fit: contain;
  display: block;
}

.choose-us-image-wrap {
  width: min(320px, 100%);
  aspect-ratio: 1 / 1;
  border-radius: 999px;
  border: 2px dashed rgba(248, 114, 31, 0.35);
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(248, 114, 31, 0.03);
}

.choose-us-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 999px;
}

/* Card Hover Styles */
.plan-card {
  transition: all 0.3s ease;
}
.btn-book-service {
  transition: all 0.3s ease;
  border-color: #ddd;
  color: #555;
  background-color: transparent;
}
.price-text {
  transition: all 0.3s ease;
  color: #000;
}
.plan-card:hover .btn-book-service {
  background-color: #F47B20;
  border-color: #F47B20;
  color: #FFF !important;
}
.plan-card:hover .price-text {
  color: #F47B20;
}

/* Pagination Dots */
.dot {
  width: 8px;
  height: 8px;
  background-color: #ddd;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s ease;
}
.dot.active, .dot:hover {
  background-color: #F47B20;
}

.service-gallery-image {
  object-fit: cover;
  height: 160px;
}

/* Specific overrides for mobile */
@media (max-width: 991.98px) {
  .slide {
    flex: 0 0 calc(100% - 20px) !important;
  }
  .service-gallery-image {
    height: 140px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .slide {
    flex: 0 0 calc(33.333% - 20px) !important;
  }
}

/* 14" / mid-desktop widths: keep CTA on one line (button left, price right) */
@media (min-width: 1200px) and (max-width: 1399.98px) {
  .plan-card-cta {
    flex-wrap: nowrap;
    gap: 12px;
  }
  .plan-card-cta .btn-book-service {
    white-space: nowrap;
    padding-left: 12px !important;
    padding-right: 12px !important;
    flex: 0 0 auto;
  }
  .plan-card-cta .price-text {
    white-space: nowrap;
    margin-left: auto;
    flex: 0 0 auto;
  }
}
</style>